// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'bars';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.688 13.502h14.624m-14.624-4.5h14.624m-14.624-4.5h14.624'
  />
);

export const viewBox = '0 0 18 18';
